module.exports = __webpack_public_path__ + "media/חגורה.382963c3.mp3";